import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface DateInputProps extends KendoWidgetProps, kendo.ui.DateInputOptions {
    children?: React.ReactNode;
}

export default class DateInput extends KendoBaseComponent<DateInputProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance = new kendo.ui.DateInput(domNode as Element, props);
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.didMount) {
            const { children, widgetRef, ...props } = this.props;

            this.widgetInstance.setOptions(props);
            (this.widgetInstance as any).value((props as any).value);
        }

        const domChild = React.Children
            .toArray(this.props.children)
            .filter((child: React.ReactElement<any>) => child && (child.type === 'input'))
            .shift();

        return domChild
            ? React.cloneElement(domChild, { ...domChild.props, ref: this.elementRef })
            : <input ref={this.elementRef} />;
    }
}



// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-react-wrapper/src/dateinput/index.tsx